// src/features/api/leadApi.ts
import { baseApi } from "../api/baseApi";

export interface Lead {
  id?: string;
  firstName: string;
  lastName?: string;
  email: string;
  phone?: string;
  source?: string; // e.g., "home_page_masterclass"
}

export interface LeadResponse {
  success: boolean;
  message?: string;
  lead?: Lead;
}

export interface CreateLeadRequest {
  firstName: string;
  email: string;
  phone?: string;
  source?: string;
}

/**
 * Inject lead endpoints into the shared baseApi so they use the same
 * baseQuery (with reauth) and middleware already wired in store.
 */
export const leadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitLead: builder.mutation<
      { success: boolean; lead?: Lead },
      Partial<Lead>
    >({
      query: (body) => ({
        url: "/leads",
        method: "POST",
        body,
      }),
      // optionally provide tags for cache invalidation
      invalidatesTags: ["Lead"],
    }),
    // add more lead-related endpoints here if needed
    createLead: builder.mutation<LeadResponse, CreateLeadRequest>({
      query: (body) => ({
        url: "/leads/create-dbc-lead",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Lead"],
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in components
export const { useSubmitLeadMutation, useCreateLeadMutation } = leadApi;
export default leadApi;
